module.exports = __webpack_public_path__ + "static/media/logo-blanco.9f17bb17.png";